export default import.meta.ROLLDOWN_FILE_URL_VN5gPtpbL6YdXnOlYcZH5w